import type { FieldValidation } from "svelte-forms2";

type Validator = (value: any) => FieldValidation | Promise<FieldValidation>;

export const phoneValidator = (): Validator => {
  return (phone: string) => {
    let valid = !!phone;

    if (valid) {
      let regExp = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/;
      let digits = phone.replace(/\D/g, "");

      valid = regExp.test(digits);
    }

    return {
      valid,
      name: "invalid_phone",
    };
  };
};

export const containsSpecialChar = () => {
  return (password: string) => {
    return {
      valid: /(?=.*[!@#$%^&*_])/.test(password),
      name: "contains_special_char",
    };
  };
};

export const containsNumber = () => {
  return (password: string) => {
    return { valid: /\d/.test(password), name: "contains_number" };
  };
};

export const minLength = () => {
  return (password: string) => {
    return {
      valid: password.length >= 8,
      name: "custom_min",
    };
  };
};
